import { CombinedGraphQLErrors } from '@apollo/client';

export const getAppSyncErrorType = (error: unknown): string | undefined => {
  if (!CombinedGraphQLErrors.is(error)) {
    return undefined;
  }

  const firstError = error.errors[0];
  if (!firstError) {
    return undefined;
  }

  if ('errorType' in firstError && typeof firstError.errorType === 'string') {
    return firstError.errorType;
  }

  const extensionErrorType = firstError.extensions?.errorType;
  return typeof extensionErrorType === 'string' ? extensionErrorType : undefined;
};

export const prodControlMealConflictErrorType = 'ProdControlMealQuantityConflictError';
